import Experience from "./Experience";
import TitleExperience from "./TitleExperience";

export default function Experiences() {
    return (
        <section className="sectionExperiences">
            <TitleExperience />
            <div className="experiences">
                {/* Internship in the Creation of an E-commerce Website */}
                <div className="experienceLeft" >
                    <Experience
                        icon="fa-solid fa-briefcase"
                        date="Mars – Mai 2024 - Stage"
                        title="Projet de Digitalisation Administrative"
                        desc="Conception et développement d’un site web pour la digitalisation complète des opérations RH à la Délégation, axé sur l’optimisation des flux de travail, l’automatisation des tâches administratives et l’amélioration de la traçabilité des processus de gestion du personnel."
                    />
                    <Experience
                        icon="fa-solid fa-briefcase"
                        date="24/26 Juin 2024 - Participation au Hackathon"
                        title="Participation au Hackathon sur l’Éducation, l’Enseignement et l’Intelligence Artificielle"
                        desc="Forum Société Numérique Berkane"
                    />
                    <Experience
                        icon="fa-solid fa-briefcase"
                        date="Avril 2024 - Stage"
                        title="Création d’un site web pour la gestion et le suivi des projets"
                        desc="Entreprise Majal Berkane, Berkane"
                    />
                    <Experience
                        icon="fa-solid fa-briefcase"
                        date="Avril/Juin 2023 - Stage"
                        title="Création d’un site web pour la gestion des emplois du temps scolaires"
                        desc="Association Life Makers, en collaboration avec ISTA, AHFIR"
                    />
                    <Experience
                        icon="fa-solid fa-briefcase"
                        date="Octobre/Décembre 2023 - Projet"
                        title="Création d’un site web pour la gestion des notes et de la présence des stagiaires"
                        desc="Projet personnel"
                    />
                    <Experience
                        icon="fa-solid fa-briefcase"
                        date="Mars 2021 - Stage"
                        title="Création d’un site e-commerce"
                        desc="Entreprise FLOWAT, Casablanca"
                    />
                </div>
            </div>
        </section>
    );
}